import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  mutation ExportCsv($csvChainId: ID, $customMultiPromptId: ID) {
    exportCsv(csvChainId: $csvChainId, customMultiPromptId: $customMultiPromptId) {
      downloadUrl
    }
  }
`;

export const exportCsv = async ({ csvChainId, customMultiPromptId }) => {
  const params = {
    query: QUERY,
    variables: {
      csvChainId,
      customMultiPromptId,
    },
  };

  const result = await executeGqlQuery(params);
  return getSingleProp(result.data);
};
